import React, { Ref, useCallback, useImperativeHandle } from 'react';

import { EstimatedTimeSelector } from './EstimatedTimeSelector';
import { TimeDisplay } from './InlineTimeSelector';
import { openModal } from '../../../core/modal/open-modal';
import { minutesFormatter } from '../../../lib/time-formatters';

export interface InlineTimePeriodSelectorRef {
  open: () => void;
}

interface InlineTimePeriodSelectorProps {
  onChange: (time: number) => void;
  time?: number;
  ref?: Ref<InlineTimePeriodSelectorRef>;
}

export const InlineTimePeriodSelector: React.FC<InlineTimePeriodSelectorProps> = ({
  time,
  onChange: onTimeChange,
  ref,
}) => {
  const handleOpenModal = useCallback(() => {
    openModal(EstimatedTimeSelector, {
      onTimeChange,
      time,
    });
  }, [time, onTimeChange]);

  useImperativeHandle(
    ref,
    () => ({
      open: () => handleOpenModal(),
    }),
    [handleOpenModal],
  );

  return (
    <TimeDisplay
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          handleOpenModal();
        }
      }}
      onClick={(e) => {
        e.stopPropagation();
        handleOpenModal();
      }}
    >
      {minutesFormatter(time || 0)}
    </TimeDisplay>
  );
};
